<div class="relative mx-4 border-b border-background-disabled pb-4 pt-[2px]">
  <div class="flex h-[28px] items-center justify-between">
    <div class="flex items-center gap-1">
      <button class="flex items-center p-[6px]" (click)="onCollapseClick()">
        @if (isCollapsed) {
          <svg-icon key="px-16-arrow-right" size="sm" class="-mt-[2px] text-primary-blue"></svg-icon>
        } @else {
          <svg-icon key="px-16-arrow-left" size="sm" class="-mt-[2px] text-primary-blue"></svg-icon>
        }
      </button>
      @if (!isCollapsed) {
        <div class="typo-h3-light" [style.opacity]="opacity === 1 ? opacity : opacity / 4">
          {{ (view === 'charting' ? 'charting_details_notes_title' : 'charting_details_notes_perio_title') | translate }}
        </div>
      }
    </div>

    @if (!isCollapsed) {
      <div
        (click)="toggleFilters()"
        class="relative z-20 flex h-[28px] w-[28px] items-center justify-center rounded-[10px]"
        [class.bg-background-light-blue]="isFiltersVisible || activeFiltersCount() > 0"
        [style.opacity]="opacity === 1 ? opacity : opacity / 4"
      >
        @if (!isFiltersVisible && activeFiltersCount() > 0) {
          <span
            class="typo-h8-bold absolute right-[-2px] top-[-2px] z-30 flex h-[14px] min-w-[14px] items-center justify-center rounded-full border border-text-white bg-primary-blue px-[3px] pt-[2px] text-text-white"
          >
            {{ activeFiltersCount() > 9 ? '9+' : activeFiltersCount() }}
          </span>
        }
        <svg-icon
          class="cursor-pointer text-primary-blue"
          key="px-16-filter"
          size="sm"
          [libUiTooltip]="!isFiltersVisible ? tooltip : undefined"
          [tooltipPosition]="'bottom'"
          [tooltipDelay]="1500"
        >
        </svg-icon>

        <ng-template #tooltip
          ><span class="text-h7">{{ 'charting_details_notes_filters_tooltip' | translate }}</span></ng-template
        >
      </div>
    }
  </div>

  @if (!isCollapsed && opacity === 1) {
    <div
      (click)="clearFilters()"
      [class.opacity-0]="!isFiltersVisible"
      [class.opacity-100]="isFiltersVisible"
      [class.visible]="isFiltersVisible"
      [class.invisible]="!isFiltersVisible"
      class="absolute bottom-0 right-0 z-10 h-[50px] w-[50px] cursor-pointer bg-gradient-to-r from-transparent to-background-white to-30% transition-opacity duration-500 ease-in-out"
    >
      <span class="absolute bottom-[22px] right-0 z-10 text-h5 font-semibold text-primary-blue">{{
        'charting_details_notes_filters_clear' | translate
      }}</span>
    </div>

    <div
      class="filters grid overflow-hidden transition-all duration-300 ease-in-out"
      [class]="isFiltersVisible ? 'mt-4 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'"
    >
      <div class="relative flex min-h-0 gap-2 overflow-x-auto pr-[50px]">
        <lib-notes-filter-item
          [type]="'type'"
          [options]="filterOptions().types"
          [value]="activeFilters().selectedTypes"
          [isDisabled]="visitsLoading"
          (filterChange)="onFilterChange('type', $event)"
        ></lib-notes-filter-item>
        <lib-notes-filter-item
          [type]="'dentalCode'"
          [options]="filterOptions().dentalCodes"
          [value]="activeFilters().selectedDentalCodes"
          [isDisabled]="visitsLoading"
          (filterChange)="onFilterChange('dentalCode', $event)"
        ></lib-notes-filter-item>
        <lib-notes-filter-item
          [type]="'status'"
          [options]="filterOptions().statuses"
          [value]="activeFilters().selectedStatuses"
          [isDisabled]="visitsLoading"
          (filterChange)="onFilterChange('status', $event)"
        ></lib-notes-filter-item>
        <lib-notes-filter-item
          [type]="'provider'"
          [options]="filterOptions().providers"
          [value]="activeFilters().selectedProviderIds"
          [isDisabled]="visitsLoading"
          (filterChange)="onFilterChange('provider', $event)"
        ></lib-notes-filter-item>
      </div>
    </div>
  }
</div>

<div class="flex h-full flex-col gap-5 overflow-auto px-4 pb-[80px]" [style.opacity]="opacity" [style.minWidth.px]="isCollapsed ? 60 : 213">
  @if (isCollapsed) {
    <div class="flex h-[calc(100%-8px)] items-center justify-center">
      <span class="typo-h3-light -rotate-90">{{
        (view === 'charting' ? 'charting_details_notes_title' : 'charting_details_notes_perio_title') | translate
      }}</span>
    </div>
  } @else {
    @if (visitsLoading) {
      <ng-lottie currentColor class="mx-auto my-5 w-5 text-primary-blue" [options]="lottieOptions"></ng-lottie>
    } @else {
      @for (visit of visits; track visit.visitId) {
        <lib-note-visit
          [id]="visit.visitDate"
          [items]="visit.allNotes"
          [visitId]="visit.visitId"
          [visitDate]="visit.visitDate"
          [expandableNotes]="true"
          [navigateOnVisitDateClick]="true"
          [isTimeZoneDifferentFromLocal]="isTimeZoneDifferentFromLocal"
          [hideNoteMenu]="true"
          (hideConditionClick)="onHideConditionClick($event)"
          (deleteProgressNoteClick)="onDeleteProgressNoteClick($event)"
          (visitDateClick)="onVisitDateClick($event)"
        />
      } @empty {
        <div class="flex h-full w-full flex-col items-center justify-center gap-4">
          <div class="flex items-center justify-center rounded-full bg-background-light-grey p-4">
            <svg-icon [key]="'px-24-history'" class="text-text-light" />
          </div>
          <div class="typo-h4-light text-text-light">
            {{ (view === 'charting' ? 'charting_details_history_empty_title' : 'charting_details_history_perio_empty_title') | translate }}
          </div>
        </div>
      }
    }
  }
</div>

<div class="absolute bottom-0 left-0 right-0 z-10 h-[80px] rounded-b-[32px] bg-gradient-to-t from-background-white to-transparent"></div>
